var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M15.55.45c.6.6.6 1.21 0 1.81L9.8 8l5.74 5.74c.6.6.6 1.2 0 1.8-.6.61-1.21.61-1.81 0L8 9.82l-5.74 5.74c-.6.6-1.2.6-1.8 0-.61-.6-.61-1.21 0-1.81L6.18 8 .45 2.26c-.6-.6-.6-1.2 0-1.8.6-.61 1.21-.61 1.81 0L8 6.18 13.74.45c.6-.6 1.2-.6 1.8 0z", "fill-rule": "nonzero" } }] }, name: "close", theme: "outlined" };
export {
  e as default
};
